import { Controller } from "@hotwired/stimulus"

export default class TabsController extends Controller {
  static classes = ["activeTab", "inactiveTab"]
  static targets = ["tab", "panel", "select"]
  static values = {
    index: 0,
  }

  connect() {
    this.showTab()

    this.element.addEventListener("turbo:before-morph-attribute", (event) => {
      const {
        detail: { attributeName },
      } = event

      if (attributeName == "data-tabs-index-value") {
        event.preventDefault()
      }
    })

    this.element.addEventListener("turbo:morph-element", () => {
      this.showTab()
    })
  }

  change(event) {
    this.indexValue = this.tabTargets.indexOf(event.currentTarget)

    this.dispatch("change", { detail: { index: this.indexValue } })
  }

  indexValueChanged() {
    this.showTab()
  }

  showTab() {
    this.panelTargets.forEach((panel, index) => {
      const tab = this.tabTargets[index]

      if (index === this.indexValue) {
        panel.classList.remove("hidden")
        if (this.hasInactiveTabClass) {
          tab?.classList?.remove(...this.inactiveTabClasses)
        }
        if (this.hasActiveTabClass) {
          tab?.classList?.add(...this.activeTabClasses)
        }
      } else {
        panel.classList.add("hidden")
        if (this.hasActiveTabClass) {
          tab?.classList?.remove(...this.activeTabClasses)
        }
        if (this.hasInactiveTabClass) {
          tab?.classList?.add(...this.inactiveTabClasses)
        }
      }
    })

    if (this.hasSelectTarget) {
      this.selectTarget.selectedIndex = this.indexValue
    }
  }
}
